/**
 * Detects React/Next.js hydration-mismatch errors from console output.
 *
 * Hydration mismatches surface as `console.error` calls (not thrown errors), so
 * they never reach `window.onerror`. This pure matcher lets the tracker promote
 * the well-known hydration messages into structured error reports.
 *
 * Pure and dependency-free; covered by __tests__/hydration.test.ts.
 */

// Substring patterns React/Next emit for hydration mismatches (lowercased).
const HYDRATION_PATTERNS = [
    'hydration failed because',
    'text content does not match server-rendered html',
    'there was an error while hydrating',
    'hydration completed but contains mismatches',
    "did not match. server:",
    'while hydrating the component',
];

// React minified hydration error codes (https://react.dev/errors).
const HYDRATION_MINIFIED_CODES = ['418', '421', '422', '423', '425'];

export function isHydrationError(message: string): boolean {
    if (!message || typeof message !== 'string') {
        return false;
    }
    const lower = message.toLowerCase();
    if (HYDRATION_PATTERNS.some((p) => lower.includes(p))) {
        return true;
    }
    // "Minified React error #418" / ".../errors/418"
    return HYDRATION_MINIFIED_CODES.some(
        (code) => lower.includes(`minified react error #${code}`) || lower.includes(`/errors/${code}`),
    );
}
